import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { useAuth } from '../../hooks/useAuth';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';

export const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log('Attempting login with:', email);
      const response = await api.post('/admin/login', { email, password });
      console.log('Login response:', response.data);
      
      // Save auth data
      login(
        response.data.access_token,
        response.data.user_type,
        response.data.user_id
      );
      
      toast.success('Login successful');
      
      // Small delay to ensure state updates
      setTimeout(() => {
        navigate('/admin/dashboard');
      }, 100);
      
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.response?.data?.detail || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="w-full max-w-md p-8 bg-white border border-slate-200 rounded-md">
        <h1 className="text-3xl font-light tracking-tight mb-2" style={{fontFamily: 'Outfit, sans-serif'}}>Admin Portal</h1>
        <p className="text-sm text-slate-500 mb-8">Sign in to manage interviews</p>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <Label htmlFor="email" data-testid="admin-login-email-label">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-login-email-input"
              className="mt-2"
            />
          </div>
          
          <div>
            <Label htmlFor="password" data-testid="admin-login-password-label">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-login-password-input"
              className="mt-2"
            />
          </div>
          
          <Button 
            type="submit" 
            className="w-full" 
            disabled={loading}
            data-testid="admin-login-submit-button"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>
      </div>
    </div>
  );
};
